export const version = {
  timeStamp: '2026-08-22 06:26:25 AM -03',
  version: '0.0.13-20260822062625',
}
